import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyDuuG42MAZi267hq3kjARa_QvnGP4pTOfc",
    authDomain: "gallery-5f92e.firebaseapp.com",
    projectId: "gallery-5f92e",
    storageBucket: "gallery-5f92e.appspot.com",
    messagingSenderId: "1054704474875",
    appId: "1:1054704474875:web:f26476ccf66ae9fb26ee5e"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const projectStorage = firebase.storage();
  const projectFirestore = firebase.firestore();
  const timestamp = firebase.firestore.FieldValue.serverTimestamp;


  const auth = firebase.auth()
  const provider = new firebase.auth.GoogleAuthProvider()

  export {projectStorage , projectFirestore , timestamp , provider , auth}
